export default {
  EMAIL: 'EMAIL',
};
